import '@trimble-agentic-internal-npm-local/agentic-chat-ui/style.css';
import ReactDOM from 'react-dom/client';
import './index.css';

import { EmbeddedApp } from './EmbeddedApp';
import './i18n';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(<EmbeddedApp />);
